import { useEffect, useState } from "react";
import { dayOf, type DayKey } from "./grid.js";

const instantNow = () => new Date().toISOString();
const dayNow = () => dayOf(instantNow());

/** Tick on the minute, and catch up immediately when a sleeping tab returns. */
export function useDiaryClock(): string {
  return useDiaryValue(instantNow);
}

/** Share one London date without re-rendering the Diary for every clock tick. */
export function useDiaryToday(): DayKey {
  return useDiaryValue(dayNow);
}

function useDiaryValue(readNow: () => string): string {
  const [now, setNow] = useState(readNow);
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const update = () => {
      clearTimeout(timer);
      setNow(readNow());
      timer = setTimeout(update, 60_000 - (Date.now() % 60_000));
    };
    update();
    window.addEventListener("focus", update);
    document.addEventListener("visibilitychange", update);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("focus", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, [readNow]);
  return now;
}
